import { useEffect, useRef } from 'react';

import { drawChart } from './drawChart';

interface ChartProps {
  data: [number, number][];
  width: number;
  height: number;
  options?: { xAxis?: { tickInterval?: d3.CountableTimeInterval; tickFormat?: string; tickStep?: number } };
}

export const Chart = ({ data, width, height, options }: ChartProps) => {
  const ref = useRef(null);
  useEffect(() => {
    if (ref.current) drawChart(ref.current, data, width, height, options);
  }, [ref, data, options]);

  return (
    <div className='container'>
      <div className='graph' ref={ref} />
    </div>
  );
};
